import {
  ComponentRef,
  Directive, ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';
import {ElementLoaderComponent} from '../../components/layout/element-loader/element-loader.component';

@Directive({
  selector: '[appElementLoader]'
})
export class ElementLoaderDirective implements OnChanges {

  @Input() appElementLoader = false;

  private componentRef: ComponentRef<ElementLoaderComponent> | null = null;

  constructor(
    private elementRef: ElementRef,
    private viewContainer: ViewContainerRef
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  update(): void {
    if (this.appElementLoader) {
      this.componentRef = this.viewContainer.createComponent(ElementLoaderComponent);

      const element = this.elementRef.nativeElement;
      element.classList.add('element-loading');
      const component: ElementLoaderComponent = this.componentRef.instance;
      component.setPosition(element.offsetLeft, element.offsetTop);
      component.setSize(element.offsetWidth, element.offsetHeight);
    } else {
      if (this.componentRef) {
        this.viewContainer.clear();
        this.componentRef = null;
      }
      this.elementRef.nativeElement.classList.remove('element-loading');
    }
  }
}
